module.exports = __webpack_public_path__ + "static/media/space.93d3f3d3.png";